// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Wy1n","inner":"Form_inner__26Dgu","range":"Form_range__5fcKI","name":"Form_name__3PeaK","actions":"Form_actions__3T3PY"};